import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import './shell.css';

const PAGE_TITLES: Record<string, string> = {
  '/credentials': 'Credenciales',
  '/reports':     'Reportes',
  '/users':       'Usuarios',
  '/settings':    'Configuración',
  '/styleguide':  'Styleguide',
};

export function AppShell() {
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] ?? 'Botica Admin';
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Mobile overlay — only rendered when sidebar is open */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            display: 'block',
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.4)',
            zIndex: 40,
          }}
        />
      )}

      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <TopBar title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main
          className="shell-main"
          style={{
            flex: 1,
            padding: 'var(--page-y) var(--page-x)',
            background: 'var(--surface-page)',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
